import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  OnInit,
  EventEmitter
} from '@angular/core';

@Component({
  selector: 'cs-modal-image',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div 
      class="cs-modal-bg"
      (click)="close.emit()"></div>
    <div 
      class="cs-modal-image"
      (click)="close.emit()">
      <!-- <button 
        class="cs-modal-image__close-button ion-close-round"
        (click)="close.emit()">
      </button> -->
      <img [src]="inputs.content.image" />
    </div>
  `
})

export class CsModalImageComponent implements OnInit {
  @Input() inputs: any = {};
  @Input() translations: any = {};

  @Output() close = new EventEmitter<Object>();

  constructor() { }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/components/cs-modal-image/cs-modal-image.component.ts